'use client';
import React, { useCallback, useEffect, useState } from 'react';
import { Spinner } from '@/components/primitives/spinner';
import Typography from '@/components/primitives/typography';
import styles from './styles.module.scss';

interface FollowButtonProps {
  isFollowing: boolean;
  isLoading?: boolean;
  onChange?: (isFollowing: boolean) => void;
}

/**
 * Component for follow button
 */
const FollowButton: React.FC<FollowButtonProps> = ({ isFollowing, isLoading = false, onChange }) => {
  const [isFollowingState, setIsFollowingState] = useState(isFollowing);

  useEffect(() => {
    setIsFollowingState(isFollowing);
  }, [isFollowing]);

  const handlePress = useCallback(() => {
    if (isLoading) return;
    setIsFollowingState(!isFollowingState);
    onChange?.call(null, !isFollowingState);
  }, [isFollowingState, isLoading, onChange]);

  return (
    <div
      onClick={handlePress}
      className={`${styles.followButton} ${isFollowingState ? styles.following : styles.notFollowing}`}
    >
      {isLoading ? (
        <Spinner size="extraSmall" color="gray" />
      ) : (
        <Typography className={`${styles.followText} ${isFollowingState ? styles.following : styles.notFollowing}`}>
          {isFollowingState ? '팔로잉' : '팔로우'}
        </Typography>
      )}
    </div>
  );
};

export default FollowButton;